
<div class="testimonial-card flex flex-col justify-between">
  <div class="stars">
    <img src="@/images/testimonials/solid-star.svg" v-for="(star, index) in testimonial.data.starsRate" :key="index" class="star-icon" />
  </div>
  <div class="testimonial-quote-container overflow-y-auto">
    <p class="testimonial-quote">{{ testimonial.data.testimonial }}</p>
  </div>
  <div class="testimonial-author">
    <img :src="testimonial.data.customerPhoto.url" :alt="`Customer ${testimonial.data.customerName} profile picture`" class="avatar" />
    <div>
      <p class="author-name">{{ testimonial.data.customerName }}</p>
    </div>
  </div>
</div>
